import { Id } from "PFTypes";

export type UnbiasedReviewer = {
  id?: Id;
  unbiased?: boolean;
  profile?: {
    id?: Id;
  };
};

export const isReviewerUnbiased = (reviewers?: UnbiasedReviewer[] | null, profileId?: Id | null): boolean => {
  if (!reviewers || !profileId) {
    return false;
  }

  const reviewer = reviewers.find((reviewer) => {
    if (reviewer && typeof reviewer === "object" && "profile" in reviewer && reviewer.profile) {
      return reviewer.profile.id === profileId;
    }
    return reviewer?.id === profileId;
  });

  return !!reviewer?.unbiased;
};
